<ng-container *ngIf="showUserComments">
  <div class="d-flex align-items-center comment-tabs b-b-tabs">
    <ul class="nav nav-pills mb-3 tools-tab-nav w-100 align-items-end" id="pills-tab" role="tablist">
      <li class="nav-item cursor-pointer" role="presentation">
        <a
          class="active"
          id="pills-listingC-tab"
          data-bs-toggle="pill"
          data-bs-target="#listingC"
          role="tab"
          aria-controls="listingC"
          aria-selected="true"
          >Listing Comments</a
        >
      </li>
      <li class="nav-item cursor-pointer" role="presentation" *ngIf="vendCommentsValid?.isDisallow">
        <a class="" id="pills-vendorC-tab" data-bs-toggle="pill" data-bs-target="#vendorC" role="tab" aria-controls="vendorC" aria-selected="false"
          >Vendor Comments&nbsp;&nbsp;{{ vendor_comment?.length > 0 ? vendor_comment?.length : '' }}
        </a>
      </li>
    </ul>
  </div>
  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="listingC" role="tabpanel" aria-labelledby="pills-listingC-tab" tabindex="0">
      <div class="w-100 d-flex align-items-ceter justify-content-between">
        <div class="p-input-icon-left w-85 mb-2 reduced-font-placeholder">
          <i class="pi pi-search"></i>
          <input (input)="onChangeFilterComments($event)" type="text" placeholder="Search Comments" style="border-radius: 10px" />
        </div>
        <div *ngIf="inOneline" class="px-2 approval">
          <ng-select
            (change)="onChangeResolvedFilter($event)"
            [items]="[
              { id: 1, label: 'Resolved', is_resolved: true },
              { id: 2, label: 'Pending', is_resolved: false },
            ]"
            bindLabel="label"
            bindValue="id"
            [searchable]="true"
            placeholder="Sort By"
            [multiple]="false"
            class="w_105 reduced-font-placeholder">
          </ng-select>
        </div>
        <div *ngIf="!inOneline" class="px-2">
          <ng-select
            (change)="onChangeResolvedFilter($event)"
            [items]="[
              { id: 1, label: 'Resolved', is_resolved: true },
              { id: 2, label: 'Pending', is_resolved: false },
            ]"
            bindLabel="label"
            bindValue="id"
            [searchable]="true"
            placeholder="Sort By"
            [multiple]="false"
            class="reduced-font-placeholder w_105">
          </ng-select>
        </div>
      </div>
      <div class="d-flex align-items-ceter w-100" *ngIf="inOneline">
        <p class="cursor-pointer mt-2" (click)="showPreview()">Preview Approval</p>
      </div>
      <p *ngIf="false">No, Comments</p>
      <div class="scroll_landing_page position-relative" (scroll)="onScroll($event)">
        <div
          class="comment-box cursor-pointer {{
            comment?.label === comments?.slice(first, first + rows)?.[indexer - 1]?.label ? 'card-indentation' : ''
          }}"
          *ngFor="let comment of comments?.slice(first, first + rows); let indexer = index"
          (click)="triggerToScroll()"
          [attr.data-approval-id]="comment?.id"
          [attr.data-approval-label]="comment?.label">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center justify-content-between">
              <div class="name-letter">
                {{ comment?.label }}
              </div>
              <div>
                <p class="f-10">{{ comment?.commented_by }}</p>
                <p class="day-ago _fw-400">{{ getMomentDateTime(comment.created_at) | customTimeAgo }}</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <i
                class="pi pi-chevron-down mr-2"
                *ngIf="isIconVisible(comment, indexer)"
                (click)="toggleChildCommentBoxes($event, comment, indexer)"></i>
              <ng-container *ngIf="readWritePermissions?.can_resolve">
                <img
                  [src]="images?.tick_icon"
                  alt=""
                  *ngIf="comment?.label !== comments?.slice(first, first + rows)?.[indexer - 1]?.label"
                  (click)="onChangeCommentStatus($event, comment)"
                  class="cursor-pointer {{
                    comment?.is_resolved && comment?.is_resolved_by_admin
                      ? 'active-approved'
                      : comment?.is_resolved && comment?.is_resolved_by_admin === false
                        ? 'active-approved-non-admin'
                        : ''
                  }}" />
              </ng-container>
            </div>
          </div>
          <p class="f-10 mt-2 _fw-400 text-truncate-two-line" [innerHTML]="comment?.message"></p>
        </div>
      </div>
      <ng-container *ngIf="listing_preview_id">
        <app-preview-listing #previewModel [id]="listing_preview_id.asObservable()"></app-preview-listing>
      </ng-container>
    </div>
    <div class="tab-pane fade" id="vendorC" role="tabpanel" aria-labelledby="pills-vendorC-tab" tabindex="0">
      <div class="comment-box cursor-pointer" *ngFor="let comment of vendor_comment; let indexer = index">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center justify-content-between">
            <div class="name-letter">
              {{ indexer + 1 }}
            </div>
            <div>
              <p class="f-12">{{ comment?.user_name }}</p>
              <p class="day-ago _fw-400">{{ getMomentDateTime(comment.created_at) | customTimeAgo }}</p>
            </div>
          </div>
        </div>
        <p class="f-10 mt-2 _fw-400 text-truncate-two-line" [innerHTML]="comment?.user_message"></p>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showPublicComments">
  <div class="mb-2 w-50">
    <input type="text" class="site-input" placeholder="Enter your name" [(ngModel)]="user_name" />
    <p class="text-danger ml-1 mt-1 f-10" *ngIf="!user_name">Name is Required</p>
  </div>
  <div class="_paragraph custom-template w-212">
    <ckeditor [(ngModel)]="user_message" placeholder="Type something..." [editor]="Editor"></ckeditor>
    <i class="pi pi-send cursor-pointer" (click)="createPublicComment()"></i>
  </div>
  <div class="comment-box cursor-pointer" *ngFor="let comment of vendor_comment; let indexer = index">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center justify-content-between">
        <div class="name-letter">
          {{ indexer + 1 }}
        </div>
        <div>
          <p class="f-12">{{ comment?.user_name }}</p>
          <p class="day-ago _fw-400">{{ getMomentDateTime(comment.created_at) | customTimeAgo }}</p>
        </div>
      </div>
    </div>
    <p class="f-10 mt-2 _fw-400 text-truncate-two-line" [innerHTML]="comment?.user_message"></p>
  </div>
</ng-container>
